var ProductBundle = class extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll('.product-bundle__item')
    this.singleProductForms = this.querySelectorAll('.product-bundle__item-single')
    this.multiProductForms = this.querySelectorAll('.product-bundle__item-multi')
    this.submitButton = this.querySelector('.product-form__submit')
    this.bundle = this.dataset.bundleProduct

    this.cartDrawer = document.querySelector('cart-drawer')

    this.setListeners()
  }

  setListeners() {
    this.singleProductForms.forEach(item => {
      item.addEventListener('change', event => this.handleVariantChange(event))
    })

    this.multiProductForms.forEach(item => {
      item.addEventListener('change', event => this.handleProductSelect(event))
    })

    this.querySelectorAll('.product-bundle__swatch-input').forEach(input => {
      input.addEventListener('click', event => this.handleSwatchClick(event))
    })

    this.querySelectorAll('.product-bundle__dropdown-input').forEach(input => {
      input.addEventListener('change', event => this.handleDropdownChange(event))
    })

    this.submitButton.addEventListener('click', event => this.addToCart(event))
  }

  // Handle variant change for single products
  handleVariantChange(event) {
    event.stopPropagation();
    const variantData = JSON.parse(event.currentTarget.querySelector('[type="application/json"]').textContent)
    const options = this.getOptions(event.currentTarget)

    if (options.length == Number(event.currentTarget.dataset.count)) {
      const currentVariant = variantData.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option
        }).includes(false)
      });


      let variantAvailable = true
      if (!currentVariant || !currentVariant.available) variantAvailable = false
      if (currentVariant) {
        event.currentTarget.dataset.id = currentVariant.id
        event.currentTarget.dataset.price = currentVariant.price
      }

      this.setButton(variantAvailable)
      this.setPrice()
    }
  }

  // Handle product select for option with multiple products
  handleProductSelect(event) {
    const selectedValue = event.currentTarget.querySelector(':checked').value
    const price = event.currentTarget.querySelector(':checked').dataset.price
    event.currentTarget.dataset.id = selectedValue
    event.currentTarget.dataset.price = price

    if (this.submitButton.disabled) this.setButton()
    this.setPrice()
  }

  handleSwatchClick(event) {
    const parent = event.currentTarget.closest('.product-bundle__item')
    const label = parent.querySelector('.product-bundle__label');
    label.innerHTML = `Color: ${event.currentTarget.value}`

    if (event.currentTarget.dataset.image) {
      parent.querySelector('.product-bundle__item-image img').src = event.currentTarget.dataset.image
    }

    this.updateVariantStatus(event.currentTarget.closest('.product-bundle__item'))
  }

  handleDropdownChange(event) {
    const label = event.currentTarget.closest('.product-bundle__dropdown').querySelector('.product-bundle__label');
    label.classList.remove('hidden');
  }

  getOptions(form) {
    let options = []
    form.querySelectorAll('.product-bundle__input').forEach(input => {
      if (input.checked || (input.tagName === 'SELECT' && input.value != 'default')) {
        options.push(input.value)
      }
    });

    return options;
  }

  updateVariantStatus(parent) {
    const variantData = JSON.parse(parent.querySelector('[type="application/json"]').textContent)
    const selectedOptionOneVariants = variantData.filter(variant => {
      return parent.querySelector(':checked').value === variant.option1
    })

    const inputWrappers = parent.querySelectorAll('.product-bundle__swatches, .product-bundle__dropdown')
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = option.querySelectorAll('input[type="radio"], option:not([value="default"])')
      const previousOptionSelected = parent.querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index + 1}`])

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.value)) {
        input.disabled = false
        input.innerHTML = input.value
      } else {
        input.disabled = true
        input.innerHTML = input.value + ' - Sold Out'
      }
    });
  }

  setButton(variantAvailable) {
    if (this.querySelector('.product-form__submit[data-sold-out]') != null) return;
    if (this.isFullySelected()) {
      if (variantAvailable == false) {
        this.submitButton.innerHTML = 'Sold Out'
          this.submitButton.disabled = true
      } else {
        this.submitButton.innerHTML = 'Add to Cart'
        this.submitButton.disabled = false
      }
    }
  }

  setPrice() {
    if (this.isFullySelected()) {
      let price = 0
      this.items.forEach(item => {
        price = price + Number(item.dataset.price)
      })
      
      const priceElements = document.querySelectorAll('.product__price')
      priceElements.forEach(priceEl => {
        const formattedPrice = Shopify.formatMoney(price)
        priceEl.innerHTML = formattedPrice
      })
    }
  }

  isFullySelected() {
    let optionCount = this.items.length
    let selectedOptionCount = 0

    this.items.forEach(item => {
      const variantId = item.dataset.id
      let available = true

      if (variantId && available) selectedOptionCount++
    })

    return optionCount == selectedOptionCount
  }

  addToCart() {
    let products = []
    this.items.forEach(item => {
      const itemObject = {
        id: Number(item.dataset.id),
        quantity: 1,
        properties: {
          'Bundle': this.bundle
        }
      }
      products.push(itemObject)
    })

    const body = JSON.stringify({
      items: products,
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartDrawer.rerender(true)
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
      });
  }
}

customElements.define('product-bundle', ProductBundle)